import { Card, Col, Row, Typography } from "antd";
import { RightOutlined } from "@ant-design/icons";
import Paragraph from "antd/lib/typography/Paragraph";
import { useState, useEffect } from "react";

import Echart from "../components/chart/EChart";
import LineChart from "../components/chart/LineChart";
import { getUserMealsUsageStatsAPI } from "../api/users";
import { getFirmwareAPI } from "../api/firmware";
import { parseFirmwareOffers } from "./firmwareUpload";

import card from "../assets/images/info-card-1.webp";

function Home() {
  const { Title, Text } = Typography;
  const [usageStats, setUsageStats] = useState(null);
  const [firmwareOffers, setFirmwareOffers] = useState({ v1: null, v2: null });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchUsageStats = async () => {
      try {
        setLoading(true);
        const response = await getUserMealsUsageStatsAPI();
        if (response && response.data) {
          setUsageStats(response.data);
        }
        const firmware = parseFirmwareOffers(await getFirmwareAPI());
        if (firmware) {
          setFirmwareOffers(firmware);
        }
      } catch (error) {
        console.error("Error fetching usage stats:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchUsageStats();
  }, []);

  const dollor = [
    <svg
      width="22"
      height="22"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      key={0}
    >
      <path
        d="M8.43338 7.41784C8.58818 7.31464 8.77939 7.2224 9 7.15101L9.00001 8.84899C8.77939 8.7776 8.58818 8.68536 8.43338 8.58216C8.06927 8.33942 8 8.1139 8 8C8 7.8861 8.06927 7.66058 8.43338 7.41784Z"
        fill="#fff"
      ></path>
      <path
        d="M11 12.849L11 11.151C11.2206 11.2224 11.4118 11.3146 11.5666 11.4178C11.9308 11.6606 12 11.8861 12 12C12 12.1139 11.9308 12.3394 11.5666 12.5822C11.4118 12.6854 11.2206 12.7776 11 12.849Z"
        fill="#fff"
      ></path>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18ZM11 5C11 4.44772 10.5523 4 10 4C9.44772 4 9 4.44772 9 5V5.09199C8.3784 5.20873 7.80348 5.43407 7.32398 5.75374C6.6023 6.23485 6 7.00933 6 8C6 8.99067 6.6023 9.76515 7.32398 10.2463C7.80348 10.5659 8.37841 10.7913 9.00001 10.908L9.00002 12.8492C8.60902 12.7223 8.31917 12.5319 8.15667 12.3446C7.79471 11.9275 7.16313 11.8827 6.74599 12.2447C6.32885 12.6067 6.28411 13.2382 6.64607 13.6554C7.20855 14.3036 8.05956 14.7308 9 14.9076L9 15C8.99999 15.5523 9.44769 16 9.99998 16C10.5523 16 11 15.5523 11 15L11 14.908C11.6216 14.7913 12.1965 14.5659 12.676 14.2463C13.3977 13.7651 14 12.9907 14 12C14 11.0093 13.3977 10.2348 12.676 9.75373C12.1965 9.43407 11.6216 9.20873 11 9.09199L11 7.15075C11.391 7.27771 11.6808 7.4681 11.8434 7.65538C12.2053 8.07252 12.8369 8.11726 13.254 7.7553C13.6712 7.39335 13.7159 6.76176 13.354 6.34462C12.7915 5.69637 11.9405 5.26915 11 5.09236V5Z"
        fill="#fff"
      ></path>
    </svg>,
  ];
  const profile = [
    <svg
      width="22"
      height="22"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      key={0}
    >
      <path
        d="M9 6C9 7.65685 7.65685 9 6 9C4.34315 9 3 7.65685 3 6C3 4.34315 4.34315 3 6 3C7.65685 3 9 4.34315 9 6Z"
        fill="#fff"
      ></path>
      <path
        d="M17 6C17 7.65685 15.6569 9 14 9C12.3431 9 11 7.65685 11 6C11 4.34315 12.3431 3 14 3C15.6569 3 17 4.34315 17 6Z"
        fill="#fff"
      ></path>
      <path
        d="M12.9291 17C12.9758 16.6734 13 16.3395 13 16C13 14.3648 12.4393 12.8606 11.4998 11.6691C12.2352 11.2435 13.0892 11 14 11C16.7614 11 19 13.2386 19 16V17H12.9291Z"
        fill="#fff"
      ></path>
      <path
        d="M6 11C8.76142 11 11 13.2386 11 16V17H1V16C1 13.2386 3.23858 11 6 11Z"
        fill="#fff"
      ></path>
    </svg>,
  ];
  const heart = [
    <svg
      width="22"
      height="22"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      key={0}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.17157 5.17157C4.73367 3.60948 7.26633 3.60948 8.82843 5.17157L10 6.34315L11.1716 5.17157C12.7337 3.60948 15.2663 3.60948 16.8284 5.17157C18.3905 6.73367 18.3905 9.26633 16.8284 10.8284L10 17.6569L3.17157 10.8284C1.60948 9.26633 1.60948 6.73367 3.17157 5.17157Z"
        fill="#fff"
      ></path>
    </svg>,
  ];
  const cart = [
    <svg
      width="22"
      height="22"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      key={0}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 2C7.79086 2 6 3.79086 6 6V7H5C4.49046 7 4.06239 7.38314 4.00612 7.88957L3.00612 16.8896C2.97471 17.1723 3.06518 17.455 3.25488 17.6669C3.44458 17.8789 3.71556 18 4 18H16C16.2844 18 16.5554 17.8789 16.7451 17.6669C16.9348 17.455 17.0253 17.1723 16.9939 16.8896L15.9939 7.88957C15.9376 7.38314 15.5096 7 15 7H14V6C14 3.79086 12.2091 2 10 2ZM12 7V6C12 4.89543 11.1046 4 10 4C8.89543 4 8 4.89543 8 6V7H12ZM6 10C6 9.44772 6.44772 9 7 9C7.55228 9 8 9.44772 8 10C8 10.5523 7.55228 11 7 11C6.44772 11 6 10.5523 6 10ZM13 9C12.4477 9 12 9.44772 12 10C12 10.5523 12.4477 11 13 11C13.5523 11 14 10.5523 14 10C14 9.44772 13.5523 9 13 9Z"
        fill="#fff"
      ></path>
    </svg>,
  ];
  const clock = [
    <svg
      width="22"
      height="22"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      key={0}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18ZM10 4C13.3137 4 16 6.68629 16 10C16 13.3137 13.3137 16 10 16C6.68629 16 4 13.3137 4 10C4 6.68629 6.68629 4 10 4ZM10 6C10.5523 6 11 6.44772 11 7V9.58579L13.7071 12.2929C14.0976 12.6834 14.0976 13.3166 13.7071 13.7071C13.3166 14.0976 12.6834 14.0976 12.2929 13.7071L9.29289 10.7071C9.10536 10.5196 9 10.2652 9 10V7C9 6.44772 9.44772 6 10 6Z"
        fill="#fff"
      ></path>
    </svg>,
  ];
  const count = [
    {
      today: "Total Sessions",
      title: usageStats?.summary?.total_sessions || "0",
      icon: profile,
      bnb: "bnb2",
    },
    {
      today: "Total Duration (Hours)",
      title: usageStats?.summary?.total_duration_hours
        ? parseFloat(usageStats.summary.total_duration_hours).toFixed(1)
        : "0",
      icon: clock,
      bnb: "bnb2",
    },
    {
      today: "Avg Duration (Minutes)",
      title: usageStats?.usage_by_state?.[0]?.avg_duration_minutes
        ? parseFloat(usageStats.usage_by_state[0].avg_duration_minutes).toFixed(
            1
          )
        : "0",
      icon: clock,
      bnb: "redtext",
    },
    {
      today: "Total Duration (Minutes)",
      title: usageStats?.summary?.total_duration_minutes
        ? parseFloat(usageStats.summary.total_duration_minutes).toFixed(0)
        : "0",
      icon: clock,
      bnb: "bnb2",
    },
  ];

  return (
    <>
      <div className="layout-content">
        <Row className="rowgap-vbox" gutter={[24, 0]}>
          {count.map((c, index) => (
            <Col
              key={index}
              xs={24}
              sm={24}
              md={12}
              lg={6}
              xl={6}
              className="mb-24"
            >
              <Card bordered={false} className="criclebox" loading={loading}>
                <div className="number">
                  <Row align="middle" gutter={[24, 0]}>
                    <Col xs={18}>
                      <span>{c.today}</span>
                      <Title level={3}>{c.title}</Title>
                    </Col>
                    <Col xs={6}>
                      <div className="icon-box">{c.icon}</div>
                    </Col>
                  </Row>
                </div>
              </Card>
            </Col>
          ))}
        </Row>

        {/* Additional Usage Stats Section */}
        {usageStats && (
          <Row gutter={[24, 0]} className="mb-24">
            <Col xs={24} sm={24} md={12} lg={12} xl={12} className="mb-24">
              <Card bordered={false} className="criclebox h-full">
                <Title level={4}>Usage Statistics</Title>
                <div className="usage-stats">
                  <Row gutter={[16, 16]}>
                    <Col span={12}>
                      <div className="stat-item">
                        <Text strong>First Usage:</Text>
                        <br />
                        <Text>
                          {usageStats.usage_by_state?.[0]?.first_usage
                            ? new Date(
                                usageStats.usage_by_state[0].first_usage
                              ).toLocaleDateString()
                            : "N/A"}
                        </Text>
                      </div>
                    </Col>
                    <Col span={12}>
                      <div className="stat-item">
                        <Text strong>Last Usage:</Text>
                        <br />
                        <Text>
                          {usageStats.usage_by_state?.[0]?.last_usage
                            ? new Date(
                                usageStats.usage_by_state[0].last_usage
                              ).toLocaleDateString()
                            : "N/A"}
                        </Text>
                      </div>
                    </Col>
                    <Col span={12}>
                      <div className="stat-item">
                        <Text strong>Current State:</Text>
                        <br />
                        <Text>
                          {usageStats.usage_by_state?.[0]?.current_state ||
                            "N/A"}
                        </Text>
                      </div>
                    </Col>
                    <Col span={12}>
                      <div className="stat-item">
                        <Text strong>Total Count:</Text>
                        <br />
                        <Text>
                          {usageStats.usage_by_state?.[0]?.total_count || "0"}
                        </Text>
                      </div>
                    </Col>
                  </Row>
                </div>
              </Card>
            </Col>
            <Col xs={24} sm={24} md={12} lg={12} xl={12} className="mb-24">
              <Card bordered={false} className="criclebox h-full">
                <Title level={4}>Firmware Information</Title>
                <div className="firmware-info">
                  <div className="stat-item">
                    <Text strong>V1 app (fleet):</Text>
                    <br />
                    <Text>
                      {firmwareOffers.v1?.version ||
                        usageStats.meta?.latest_firmware?.version ||
                        "N/A"}
                    </Text>
                  </div>
                  <div className="stat-item">
                    <Text strong>V2 app only:</Text>
                    <br />
                    <Text>{firmwareOffers.v2?.version || "Not published"}</Text>
                  </div>
                  <div className="stat-item">
                    <Text strong>V1 Firmware URL:</Text>
                    <br />
                    <Text>
                      <a
                        href={
                          firmwareOffers.v1?.url ||
                          usageStats.meta?.latest_firmware?.url
                        }
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Download V1
                      </a>
                    </Text>
                  </div>
                  {firmwareOffers.v2?.url ? (
                    <div className="stat-item">
                      <Text strong>V2 Firmware URL:</Text>
                      <br />
                      <Text>
                        <a
                          href={firmwareOffers.v2.url}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Download V2
                        </a>
                      </Text>
                    </div>
                  ) : null}
                </div>
              </Card>
            </Col>
          </Row>
        )}

        <Row gutter={[24, 0]}>
          <Col xs={24} sm={24} md={12} lg={12} xl={10} className="mb-24">
            <Card bordered={false} className="criclebox h-full">
              <Echart />
            </Card>
          </Col>
          <Col xs={24} sm={24} md={12} lg={12} xl={14} className="mb-24">
            <Card bordered={false} className="criclebox h-full">
              <LineChart />
            </Card>
          </Col>
        </Row>
        {/* 
        <Row gutter={[24, 0]}>
          <Col xs={24} sm={24} md={12} lg={12} xl={16} className="mb-24">
            <Card bordered={false} className="criclebox cardbody h-full">
              <div className="project-ant">
                <div>
                  <Title level={5}>Projects</Title>
                  <Paragraph className="lastweek">
                    done this month<span className="blue">40%</span>
                  </Paragraph>
                </div>
                <div className="ant-filtertabs">
                  <div className="antd-pro-pages-dashboard-analysis-style-salesExtra">
                    <Radio.Group onChange={onChange} defaultValue="a">
                      <Radio.Button value="a">ALL</Radio.Button>
                      <Radio.Button value="b">ONLINE</Radio.Button>
                      <Radio.Button value="c">STORES</Radio.Button>
                    </Radio.Group>
                  </div>
                </div>
              </div>
              <div className="ant-list-box table-responsive">
                <table className="width-100">
                  <thead>
                    <tr>
                      <th>COMPANIES</th>
                      <th>MEMBERS</th>
                      <th>BUDGET</th>
                      <th>COMPLETION</th>
                    </tr>
                  </thead>
                  <tbody>
                    {list.map((d, index) => (
                      <tr key={index}>
                        <td>
                          <h6>
                            <img
                              src={d.img}
                              alt=""
                              className="avatar-sm mr-10"
                            />{" "}
                            {d.Title}
                          </h6>
                        </td>
                        <td>{d.member}</td>
                        <td>
                          <span className="text-xs font-weight-bold">
                            {d.bud}{" "}
                          </span>
                        </td>
                        <td>
                          <div className="percent-progress">{d.progress}</div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <div className="uploadfile shadow-none">
                <Upload {...uploadProps}>
                  <Button
                    type="dashed"
                    className="ant-full-box"
                    icon={<ToTopOutlined />}
                  >
                    <span className="click">Click to Upload</span>
                  </Button>
                </Upload>
              </div>
            </Card>
          </Col>
          <Col xs={24} sm={24} md={12} lg={12} xl={8} className="mb-24">
            <Card bordered={false} className="criclebox h-full">
              <div className="timeline-box">
                <Title level={5}>Orders History</Title>
                <Paragraph className="lastweek" style={{ marginBottom: 24 }}>
                  this month <span className="bnb2">20%</span>
                </Paragraph>

                <Timeline
                  pending="Recording..."
                  className="timelinelist"
                  reverse={reverse}
                >
                  {timelineList.map((t, index) => (
                    <Timeline.Item color={t.color} key={index}>
                      <Title level={5}>{t.title}</Title>
                      <Text>{t.time}</Text>
                    </Timeline.Item>
                  ))}
                </Timeline>
                <Button
                  type="primary"
                  className="width-100"
                  onClick={() => setReverse(!reverse)}
                >
                  {<MenuUnfoldOutlined />} REVERSE
                </Button>
              </div>
            </Card>
          </Col>
        </Row> */}

        <Row gutter={[24, 0]}>
          <Col xs={24} md={12} sm={24} lg={12} xl={14} className="mb-24">
            <Card bordered={false} className="criclebox h-full">
              <Row gutter>
                <Col
                  xs={24}
                  md={12}
                  sm={24}
                  lg={12}
                  xl={14}
                  className="mobile-24"
                >
                  <div className="h-full col-content p-20">
                    <div className="ant-muse">
                      <Text>About Figo Device</Text>
                      <Title level={5}>Designed for Your Lifestyle</Title>
                      <Paragraph className="lastweek mb-36">
                        Figo's proprietary cooling system keeps your meals
                        safely refrigerated until it's time to cook.
                      </Paragraph>
                    </div>
                    <div className="card-footer">
                      <a
                        className="icon-move-right"
                        href="https://eatfigo.com/"
                        target="blank"
                      >
                        Read More
                        {<RightOutlined />}
                      </a>
                    </div>
                  </div>
                </Col>
                <Col
                  xs={24}
                  md={12}
                  sm={24}
                  lg={12}
                  xl={10}
                  className="col-img"
                >
                  <div className="ant-cret text-right">
                    <img src={card} alt="" className="border10" />
                  </div>
                </Col>
              </Row>
            </Card>
          </Col>

          <Col xs={24} md={12} sm={24} lg={12} xl={10} className="mb-24">
            <Card bordered={false} className="criclebox card-info-2 h-full">
              <div className="gradent h-full col-content">
                <div className="card-content">
                  <Title level={5}>Eat Figo Device</Title>
                  <p>
                    The countertop refrigerator that cooks your food to
                    restaurant quality. On your time. Every time.
                  </p>
                </div>
                <div className="card-footer">
                  <a
                    className="icon-move-right"
                    href="https://eatfigo.com/"
                    target="blank"
                  >
                    Read More
                    <RightOutlined />
                  </a>
                </div>
              </div>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
}

export default Home;
